import { Fragment, useState } from "react";
import { Col, Container, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H4} from "../AbstractElements";

import { useNavigate } from "react-router-dom";

import { ToastContainer, toast } from "react-toastify";
import { apiClient } from "../multyhealth/api/api";

const Signin = ({ selected }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [togglePassword, setTogglePassword] = useState(false);
  const history = useNavigate();


  

  const loginAuth = async (e) => {
    e.preventDefault();

    try {
      const response = await apiClient.post("/administrators/login", {
        email: email,
        password: password,
      });

      localStorage.setItem("token", response.data.data.token);
      window.location.href = "/dashboard";
    } catch (error) {
      toast.error("Correo o contraseña incorrectos.");
      console.error("Error durante el inicio de sesión:", error);
      return;
    }
  };

  return (
    <Fragment>
      <Container fluid={true} className="p-0 login-page">
        <Row>
          <Col xs="12">
            <div className="login-card">
              <div className="login-main login-tab">
                <Form className="theme-form">
                  <H4>{selected === "simpleLogin" ? "" : "Iniciar Sesión"}</H4>
                  <FormGroup>
                    <Label className="col-form-label">Correo electrónico</Label>
                    <Input
                      className="form-control"
                      type="email"
                      onChange={(e) => setEmail(e.target.value)}
                      value={email}
                    />
                  </FormGroup>
                  <FormGroup className="position-relative">
                    <Label className="col-form-label">Contraseña</Label>
                    <div className="position-relative">
                      <Input
                        className="form-control"
                        type={togglePassword ? "text" : "password"}
                        onChange={(e) => setPassword(e.target.value)}
                        value={password}
                      />
                      <div
                        className="show-hide"
                        onClick={() => setTogglePassword(!togglePassword)}
                      >
                        <span className={togglePassword ? "" : "show"}></span>
                      </div>
                    </div>
                  </FormGroup>
                  <div className="position-relative form-group mb-0">
                    <div className="checkbox">
                      <Input id="checkbox1" type="checkbox" />
                      <Label className="text-muted" for="checkbox1">
                        Recordar contraseña
                      </Label>
                    </div>
                    <a className="link" href="#javascript">
                      ¿Olvidaste tu contraseña?
                    </a>
                    <Btn
                      attrBtn={{
                        color: "primary",
                        className: "d-block w-100 mt-2",
                        onClick: (e) => loginAuth(e),
                      }}
                    >
                      Iniciar Sesión
                    </Btn>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <ToastContainer />
    </Fragment>
  );
};

export default Signin;
